import { useIsBunnyProvider } from "@/partner/entities/platforms";

export interface VideoProviderTextKeys {
  filterStreamNotConnectedTooltip: string;
  listStreamNotConnectedTitle: string;
  listStreamNotConnectedDescription: string;
  toolbarDeleteConfirm: string;
  createUrlHelper: string;
  createUrlSuccess: string;
  playerPreviewProcessing: string;
}

/**
 * Тексты видео, в которых назван провайдер. У Cloudflare и Bunny свои
 * формулировки: «Файлы в Cloudflare будут удалены» на adult-инстансе
 * просто неверно, и партнёру нечего с ней делать.
 *
 * CRITICAL-RULES.md, i18n partner-кабинета: ключ i18n только статический
 * литерал, выбор текста по провайдеру через явную мапу, а не шаблонной
 * строкой. Тот же приём, что CARD_TEXT_KEYS в StreamingUsageCard и
 * тексты `domainSettings.bunny.*` в DomainSettingsCard.
 */
const VIDEO_PROVIDER_TEXT_KEYS: Record<
  "cloudflare" | "bunny",
  VideoProviderTextKeys
> = {
  cloudflare: {
    filterStreamNotConnectedTooltip: "videos.filter.streamNotConnectedTooltip",
    listStreamNotConnectedTitle: "videos.list.streamNotConnectedTitle",
    listStreamNotConnectedDescription:
      "videos.list.streamNotConnectedDescription",
    toolbarDeleteConfirm: "videos.toolbar.deleteConfirm",
    createUrlHelper: "videos.create.urlHelper",
    createUrlSuccess: "videos.create.urlSuccess",
    playerPreviewProcessing: "videos.playerPreview.processing",
  },
  bunny: {
    filterStreamNotConnectedTooltip:
      "videos.bunny.filter.streamNotConnectedTooltip",
    listStreamNotConnectedTitle: "videos.bunny.list.streamNotConnectedTitle",
    listStreamNotConnectedDescription:
      "videos.bunny.list.streamNotConnectedDescription",
    toolbarDeleteConfirm: "videos.bunny.toolbar.deleteConfirm",
    createUrlHelper: "videos.bunny.create.urlHelper",
    createUrlSuccess: "videos.bunny.create.urlSuccess",
    playerPreviewProcessing: "videos.bunny.playerPreview.processing",
  },
};

export function useVideoProviderTextKeys(): VideoProviderTextKeys {
  return useIsBunnyProvider()
    ? VIDEO_PROVIDER_TEXT_KEYS.bunny
    : VIDEO_PROVIDER_TEXT_KEYS.cloudflare;
}
